module.exports = __webpack_public_path__ + "static/media/abicon2.80fb7dfc.webp";